import { Outlet } from "react-router-dom";

export default function SecondaryLayout() {
  return (
    <div className="content">
      <Outlet />
    </div>
  );
}
